import React, { useRef } from 'react';
import * as Icon from 'react-bootstrap-icons';
import {useTranslation} from "react-i18next";

export const BarcodeInput = ({
    value,
    setValue,
    placeholder,
    submit,
}) => {
    const {t} = useTranslation();
    const inputRef= useRef();
    return (
        <form onSubmit={(e) => {
            e.preventDefault(); // Prevent page reload
            if (value !== "") {
                submit();
            }
        }} className='row'>
            <div className='col-12 col-md-9'>
                <input
                    ref={inputRef}
                    autoFocus={true}
                    className="form-control w-100 mb-3"
                    value={value}
                    placeholder={placeholder}
                    onChange={(e) => {
                        setValue(e.target.value);
                    }}
                />
            </div>
            <div className='col-12 col-md-3'>
                <button disabled={value === ""} type="submit" onClick={() => submit()} className={'btn btn-primary w-100'}>
                    <Icon.Save /> {t('common.save')}
                </button>
            </div>
      </form>
  )
}
export default BarcodeInput;